import { useState } from 'react';

export default function TrainingGallery() {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);
  const [activeCategory, setActiveCategory] = useState('all');

  const trainingImages = [
    {
      id: 1,
      category: 'aviation',
      title: 'Aviation CPR Training',
      location: 'Private Jet Cabin',
      image: 'https://public.readdy.ai/ai/img_res/ad61567b599995f24afd817c590c6179.jpg',
      description: 'Intensive CPR and cardiac emergency training for aviation crew in realistic cabin environment.'
    },
    {
      id: 2,
      category: 'maritime',
      title: 'Yacht Deck Emergency Response',
      location: 'Superyacht Deck',
      image: 'https://readdy.ai/api/search-image?query=medical-trainers-in-white-polo-shirts-conducting-emergency-response-training-with-yacht-crew-in-white-uniforms-on-luxury-superyacht-deck-practical-medical-equipment-demonstration-ocean-background-bright-sunlight-professional-maritime-training-active-learning-session&width=900&height=600&seq=training002maritime&orientation=landscape',
      description: 'Maritime crew learning offshore emergency protocols and evacuation coordination on yacht deck.'
    },
    {
      id: 3,
      category: 'estate',
      title: 'Estate Staff AED Training',
      location: 'Private Residence',
      image: 'https://readdy.ai/api/search-image?query=diverse-estate-staff-members-in-professional-attire-learning-AED-operation-with-medical-instructor-in-elegant-luxury-private-residence-interior-hands-on-defibrillator-training-sophisticated-home-environment-focused-medical-education-session&width=900&height=600&seq=training003estate&orientation=landscape',
      description: 'Estate household staff receiving comprehensive AED and emergency response training.'
    },
    {
      id: 4,
      category: 'security',
      title: 'Tactical Medical Response',
      location: 'Training Facility',
      image: 'https://readdy.ai/api/search-image?query=security-professionals-in-dark-tactical-suits-receiving-tactical-medical-training-from-instructors-in-white-shirts-modern-training-facility-emergency-response-scenarios-professional-equipment-focused-intensive-learning-environment-executive-protection-medical-integration&width=900&height=600&seq=training004security&orientation=landscape',
      description: 'Security team integrating tactical medical response with executive protection protocols.'
    },
    {
      id: 5,
      category: 'hospitality',
      title: 'Hotel Staff Medical Protocols',
      location: 'Five-Star Hotel',
      image: 'https://readdy.ai/api/search-image?query=luxury-hotel-staff-in-elegant-uniforms-receiving-VIP-guest-medical-emergency-training-from-professional-instructor-five-star-hotel-conference-room-discreet-emergency-response-protocols-sophisticated-hospitality-environment-professional-medical-education&width=900&height=600&seq=training005hospitality&orientation=landscape',
      description: 'Luxury hospitality team learning VIP guest medical privacy and discreet emergency response.'
    },
    {
      id: 6,
      category: 'aviation',
      title: 'Flight Crew Medical Equipment',
      location: 'Aircraft Training Center',
      image: 'https://readdy.ai/api/search-image?query=aviation-crew-members-in-pilot-uniforms-learning-medical-equipment-operation-with-instructors-in-white-coats-aircraft-training-center-emergency-medical-kits-oxygen-systems-AED-devices-professional-aviation-medical-training-detailed-equipment-demonstration&width=900&height=600&seq=training006aviationequip&orientation=landscape',
      description: 'Aviation professionals mastering in-flight medical equipment operation and emergency protocols.'
    },
    {
      id: 7,
      category: 'maritime',
      title: 'Offshore Trauma Management',
      location: 'Yacht Medical Bay',
      image: 'https://readdy.ai/api/search-image?query=yacht-crew-members-in-white-maritime-uniforms-practicing-trauma-care-techniques-with-medical-trainers-luxury-yacht-medical-bay-realistic-injury-simulation-professional-medical-supplies-intensive-hands-on-maritime-emergency-training&width=900&height=600&seq=training007maritimetrauma&orientation=landscape',
      description: 'Maritime crew practicing extended care protocols for offshore medical emergencies.'
    },
    {
      id: 8,
      category: 'estate',
      title: 'Pediatric Emergency Care',
      location: 'Estate Training Room',
      image: 'https://readdy.ai/api/search-image?query=estate-staff-members-learning-pediatric-emergency-care-with-child-medical-mannequin-professional-instructor-in-white-coat-elegant-private-residence-training-room-child-CPR-techniques-choking-response-sophisticated-household-medical-training&width=900&height=600&seq=training008estatepediatric&orientation=landscape',
      description: 'Estate staff receiving specialized training in pediatric medical emergencies and child care protocols.'
    },
    {
      id: 9,
      category: 'security',
      title: 'Executive Protection Medical',
      location: 'Security Training Center',
      image: 'https://readdy.ai/api/search-image?query=security-team-in-black-suits-practicing-executive-protection-medical-scenarios-with-trainers-in-white-shirts-professional-security-training-facility-tactical-medical-response-integration-realistic-emergency-simulations-focused-intensive-training-environment&width=900&height=600&seq=training009securityexec&orientation=landscape',
      description: 'Security professionals learning to integrate medical response with close protection operations.'
    },
    {
      id: 10,
      category: 'hospitality',
      title: 'Multi-Lingual Medical Communication',
      location: 'Resort Training Center',
      image: 'https://readdy.ai/api/search-image?query=diverse-international-hotel-staff-in-elegant-uniforms-learning-multi-lingual-medical-communication-with-instructor-luxury-resort-training-center-language-cards-medical-terminology-professional-hospitality-medical-training-inclusive-learning-environment&width=900&height=600&seq=training010hospitalitylang&orientation=landscape',
      description: 'International hospitality team mastering medical communication across multiple languages.'
    },
    {
      id: 11,
      category: 'aviation',
      title: 'High-Altitude Crisis Management',
      location: 'Flight Simulator',
      image: 'https://readdy.ai/api/search-image?query=cabin-crew-members-in-aviation-uniforms-practicing-high-altitude-medical-crisis-management-flight-simulator-environment-oxygen-systems-emergency-descent-protocols-realistic-aircraft-cabin-setting-intensive-aviation-medical-scenario-training&width=900&height=600&seq=training011aviationaltitude&orientation=landscape',
      description: 'Aviation crew training for medical emergencies in high-altitude confined environments.'
    },
    {
      id: 12,
      category: 'maritime',
      title: 'Helicopter Evacuation Coordination',
      location: 'Yacht Helipad',
      image: 'https://readdy.ai/api/search-image?query=yacht-crew-in-white-uniforms-practicing-helicopter-medical-evacuation-coordination-luxury-superyacht-helipad-medical-stretcher-preparation-communication-protocols-ocean-background-professional-maritime-emergency-evacuation-training&width=900&height=600&seq=training012maritimeheli&orientation=landscape',
      description: 'Maritime professionals learning helicopter evacuation procedures for offshore medical emergencies.'
    }
  ];

  const categories = [
    { id: 'all', label: 'All Training', icon: 'ri-grid-line' },
    { id: 'aviation', label: 'Aviation', icon: 'ri-plane-line' },
    { id: 'maritime', label: 'Maritime', icon: 'ri-ship-line' },
    { id: 'estate', label: 'Estate', icon: 'ri-home-4-line' },
    { id: 'security', label: 'Security', icon: 'ri-shield-user-line' },
    { id: 'hospitality', label: 'Hospitality', icon: 'ri-hotel-line' }
  ];

  const filteredImages = activeCategory === 'all' 
    ? trainingImages 
    : trainingImages.filter(img => img.category === activeCategory);

  return (
    <section className="bg-[#0D0D0D] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="text-[9px] uppercase tracking-[0.2em] text-[#707070] font-light mb-4">
            Training In Action
          </div>
          <h2 className="text-[40px] sm:text-[48px] md:text-[56px] font-bold text-[#F5F5F5] mb-6 font-serif">
            Training Gallery
          </h2>
          <p className="text-[16px] text-[#9A9A9A] max-w-[800px] mx-auto leading-relaxed">
            Experience our world-class training programs through real sessions with aviation crews, maritime professionals, estate staff, security teams, and hospitality personnel.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setActiveCategory(category.id)}
              className={`px-6 py-3 rounded-lg text-[14px] font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2 ${
                activeCategory === category.id
                  ? 'bg-[#D4C4B0] text-black'
                  : 'bg-[#111111] text-[#C0C0C0] border border-[#222222] hover:border-[#D4C4B0]'
              }`}
            >
              <i className={`${category.icon} text-[18px]`}></i>
              {category.label}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredImages.map((image) => (
            <div
              key={image.id}
              onClick={() => setSelectedImage(image.id)}
              className="group relative bg-black border border-[#1A1A1A] rounded-2xl overflow-hidden hover:border-[#D4C4B0] transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-[320px] overflow-hidden">
                <img
                  src={image.image}
                  alt={image.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent"></div>
                
                <div className="absolute top-4 left-4">
                  <div className="px-3 py-1 bg-[#D4C4B0] text-black text-[11px] font-semibold uppercase tracking-wider rounded-full">
                    {categories.find(c => c.id === image.category)?.label}
                  </div>
                </div>

                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-[20px] font-bold text-white mb-2 group-hover:text-[#D4C4B0] transition-colors duration-300">
                    {image.title}
                  </h3>
                  <div className="flex items-center gap-2 text-[13px] text-[#C0C0C0] mb-3">
                    <i className="ri-map-pin-line"></i>
                    <span>{image.location}</span>
                  </div>
                  <p className="text-[14px] text-[#A0A0A0] leading-relaxed">
                    {image.description}
                  </p>
                </div>

                <div className="absolute top-4 right-4 w-10 h-10 bg-black/50 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className="ri-zoom-in-line text-[20px] text-white"></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 bg-[#111111] border border-[#222222] rounded-xl px-6 py-4">
            <i className="ri-camera-line text-[24px] text-[#D4C4B0]"></i>
            <div className="text-left">
              <div className="text-[14px] font-semibold text-[#F5F5F5]">
                Showing {filteredImages.length} Training Sessions
              </div>
              <div className="text-[12px] text-[#808080]">
                Real training environments with professional crews
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20 bg-[#111111] border border-[#222222] rounded-2xl p-8 md:p-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-[32px] font-bold text-[#F5F5F5] mb-4 font-serif">
                Experience Training Excellence
              </h3>
              <p className="text-[16px] text-[#9A9A9A] leading-relaxed mb-6">
                Our training programs combine theoretical knowledge with intensive hands-on practice in realistic environments. Every session is designed to build confidence, competence, and life-saving skills.
              </p>
              <div className="space-y-3">
                {[
                  'Realistic training environments',
                  'Experienced medical instructors',
                  'Hands-on practical scenarios',
                  'Industry-specific protocols'
                ].map((feature, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <i className="ri-checkbox-circle-fill text-[#D4C4B0] text-[20px]"></i>
                    <span className="text-[15px] text-[#C0C0C0]">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex justify-center lg:justify-end">
              <a
                href="#contact"
                className="inline-block px-8 py-4 bg-[#D4C4B0] text-black text-[14px] font-semibold rounded-lg hover:bg-[#C4B4A0] transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Schedule Your Training Session
              </a>
            </div>
          </div>
        </div>
      </div>

      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative max-w-[1200px] w-full" onClick={(e) => e.stopPropagation()}>
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute -top-12 right-0 w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors duration-300 cursor-pointer"
            >
              <i className="ri-close-line text-[24px] text-white"></i>
            </button>
            <div className="bg-[#0D0D0D] border border-[#1A1A1A] rounded-2xl overflow-hidden">
              <img
                src={trainingImages.find(img => img.id === selectedImage)?.image}
                alt="Training Session"
                className="w-full h-auto"
              />
              <div className="p-6">
                <h3 className="text-[24px] font-bold text-[#F5F5F5] mb-2">
                  {trainingImages.find(img => img.id === selectedImage)?.title}
                </h3>
                <div className="flex items-center gap-2 text-[14px] text-[#D4C4B0] mb-3">
                  <i className="ri-map-pin-line"></i>
                  <span>{trainingImages.find(img => img.id === selectedImage)?.location}</span>
                </div>
                <p className="text-[15px] text-[#A0A0A0] leading-relaxed">
                  {trainingImages.find(img => img.id === selectedImage)?.description}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
